
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-71c01394\",\"scoped\":true,\"hasInlineConfig\":false}!autoprefixer-loader!less-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/iview-loader/index.js??ref--1-1!./header-and-footer.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/iview-loader/index.js??ref--1-1!./header-and-footer.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-71c01394\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/iview-loader/index.js??ref--1-1!./header-and-footer.vue"),
  /* scopeId */
  "data-v-71c01394",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins/workspace/yzs-prod/duckbillscm-web-prod/src/components/header-and-footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] header-and-footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71c01394", Component.options)
  } else {
    hotAPI.reload("data-v-71c01394", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/header-and-footer.vue
// module id = 645
// module chunks = 61